// extracted by mini-css-extract-plugin
export default {"title":"LoadingUIBlockerContainer_title__XW476","info":"LoadingUIBlockerContainer_info__fIrP1"};